import styled from "styled-components";
import {styledByDevice} from "../../../themes/architecture/styled-by-device";

const DefaultBox = styled.div`
  margin: 0 0 0 0.5em;
  padding: 0 0 0 0.5em;
  border-left: 1px solid ${props => props.theme.colors.textMiddleDark};

  .last-login-container {
    display: flex;
    font-size: 1rem;
    ${({theme}) => theme.font.presets.regular};
    line-height: 1;
  }
`;

const PcBox = styled(DefaultBox)`
  .last-login-container {
    flex-direction: column;
  }

  .last-login-title-text {
    font-size: 1.1rem;
    padding-bottom: 0.5rem;
  }

  .last-login-result-text {
    font-size: 1rem;
    white-space: nowrap;
  }
`;

const MobileBox = styled(DefaultBox)`
  .last-login-container {
    flex-direction: row;
    align-items: center;
  }

  .last-login-title-text {
    display: inline-block;
    padding-right: 0.5rem;
  }

  .last-login-result-text {
    display: inline-block;
  }
`;

export const LastLoginDefaultBox = styledByDevice(PcBox, MobileBox);
